export default __webpack_public_path__ + "static/media/bitcoin.bc93a237.svg";